import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonsModule } from '../../commons/commons.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// components
import { MatIconModule } from '@angular/material/icon';
import { ComponentsModule } from '../../components/component.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MenuModule } from 'primeng/menu';
import { GroupsComponent } from './groups.component';
import { LayoutTableModule } from 'projects/access-control/src/app/UI/commons/layout-table/layout-table.module';
import { ActionsTableModule } from 'projects/access-control/src/app/UI/commons/actions-table/actions-table.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipesModule } from 'projects/access-control/src/app/Infrastructure/pipes/pipes.module';
import { SubSidebarModule } from 'projects/access-control/src/app/UI/commons/sub-sidebar/sub-sidebar.module';
import { GeneralComponent } from './components/general/general.component';
import { StatusComponent } from './components/status/status.component';
import { SecurityComponent } from './components/security/security.component';
import { BreadcrumbModule } from 'projects/access-control/src/app/UI/commons/breadcrumb/breadcrumb.module';
import { SliderModule } from 'primeng/slider';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProfileComponent } from './components/profile/profile.component';
import { PasswordModule } from 'primeng/password';
import { UsersGroupsComponent } from './components/users-groups/users-groups.component';
import { VerticalLineModule } from 'projects/access-control/src/app/UI/commons/vertical-line/vertical-line.module';
import { DirectivesModule } from 'projects/access-control/src/app/Infrastructure/directive/directives.module';
import { loadingSpinnerModule } from 'projects/access-control/src/app/UI/commons/loading-spinner/loading-spinner.module';
import { TooltipModule } from 'primeng/tooltip';
import { TableUserModule } from 'projects/access-control/src/app/UI/components/table-users/table.users.module';

const routes: Routes = [
	{
		path: '',
		component: GroupsComponent,
	},
];

@NgModule({
	declarations: [
		GroupsComponent,
		GeneralComponent,
		StatusComponent,
		SecurityComponent,
		ProfileComponent,
		UsersGroupsComponent,
	],
	exports: [GroupsComponent],
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		MatIconModule,
		ComponentsModule,
		FormsModule,
		SliderModule,
		ReactiveFormsModule,
		VerticalLineModule,
		TableUserModule,
		PasswordModule,
		SubSidebarModule,
		MatDialogModule,
		InputSwitchModule,
		BreadcrumbModule,
		DirectivesModule,
		loadingSpinnerModule,
		PipesModule,
		MenuModule,
		LayoutTableModule,
		CommonsModule,
		MatTooltipModule,
		ActionsTableModule,
		NgxDatatableModule,
		TooltipModule,
	],
	providers: [DatePipe],
})
export class GroupsModule {}
